import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });

const CHAT_RESTRICTED_ROUTE_PATTERN =
  /^(inbox_conversation|conversation_through_|conversations_through_|conversation_mentions|conversation_unattended|inbox_dashboard|home$|folder_conversations|team_conversations|label_conversations)/;

const isChatRestrictedRoute = routeName =>
  routeName === 'home' || CHAT_RESTRICTED_ROUTE_PATTERN.test(routeName || '');

const hasChatView = () => {
  const account = store.getters.getCurrentAccount || {};
  if (account.super_admin === true) return true;
  const fp = account.feature_permissions;
  if (!fp || fp._mode !== 'custom') return true;
  return (fp.modules || {})['chat.view'] === true;
};

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (to.name === 'no_accounts' || !to.name) {
    return next(frontendURL(`accounts/${accountId}/dashboard`));
  }

  if (!hasChatView() && isChatRestrictedRoute(to.name)) {
    return next(frontendURL(`accounts/${accountId}/pipelines`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
